import {
  Anchor,
  Box,
  Button,
  Center,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
  Alert,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { IconAlertCircle, IconCircleCheck, IconMail } from '@tabler/icons-react';
import { apiClient } from '../api/http';
import { getErrorMessage } from '../api/client';

/**
 * Sprint 5.2: pagina publica para pedir un enlace de recuperacion de
 * password. Muestra siempre el mismo mensaje OK tras enviar (anti-
 * enumeracion: el backend ya devuelve 200 aunque el email no exista).
 */
export function ForgotPassword() {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const form = useForm({
    initialValues: { email: '' },
    validate: {
      email: (v) => (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? null : 'Email no valido'),
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    setSubmitting(true);
    setError(null);
    try {
      await apiClient.post('/auth/forgot-password', { email: values.email.trim() });
      setSubmitted(true);
    } catch (e) {
      setError(getErrorMessage(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Center mih="100vh" bg="deca.0">
      <Box p="xl" bg="white" style={{ borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <Stack gap="md" maw={400}>
          <Stack align="center" gap={4}>
            <IconMail size={32} color="var(--mantine-color-deca-9)" />
            <Title order={2} c="deca.9" ta="center">
              Recuperar password
            </Title>
            <Text size="sm" c="dimmed" ta="center">
              Te enviaremos un enlace para crear una nueva password.
            </Text>
          </Stack>

          {submitted ? (
            <Alert color="green" variant="light" icon={<IconCircleCheck size={20} />}>
              <Stack gap={4}>
                <Text fw={600}>Solicitud enviada</Text>
                <Text size="sm">
                  Si el email existe en nuestro sistema, te hemos enviado un enlace
                  para crear una nueva password. Revisa tu bandeja (y la carpeta de
                  spam).
                </Text>
                <Text size="sm" mt="xs">
                  <Anchor component={Link} to="/login">
                    Volver al inicio de sesion
                  </Anchor>
                </Text>
              </Stack>
            </Alert>
          ) : (
            <>
              {error && (
                <Alert color="red" variant="light" icon={<IconAlertCircle size={20} />}>
                  {error}
                </Alert>
              )}
              <form onSubmit={form.onSubmit(handleSubmit)}>
                <Stack>
                  <TextInput
                    label="Email"
                    type="email"
                    placeholder="juan@miempresa.com"
                    required
                    {...form.getInputProps('email')}
                  />
                  <Button type="submit" loading={submitting} color="deca.9" fullWidth>
                    Enviar enlace de recuperacion
                  </Button>
                  <Text size="sm" c="dimmed" ta="center">
                    <Anchor component={Link} to="/login">
                      Volver al inicio de sesion
                    </Anchor>
                  </Text>
                </Stack>
              </form>
            </>
          )}
        </Stack>
      </Box>
    </Center>
  );
}